export const AccountStatuses = {
	SCHEDULED: "Scheduled",
	CANCELED: "Canceled",
	SOLD: "Sold",
	RESCHEDULED: "Rescheduled",
	COMPLETED: "Completed",
};

export const getStatusColor = (status) => {
	switch (status) {
		case AccountStatuses.SCHEDULED:
			return "bg-[#E3F5FF] text-[#0078D4] border-[#0078D4]"; // Light blue with darker blue text
		case AccountStatuses.CANCELED:
			return "bg-[#FECDCA] text-[#D92D20] border-[#D92D20]"; // From UI design - light red with red text
		case AccountStatuses.SOLD:
			return "bg-[#DCFCE7] text-[#039855] border-[#039855]"; // Light green with green text
		case AccountStatuses.RESCHEDULED:
			return "bg-[#E6EBFF] text-[#3E63DD] border-[#3E63DD]"; // From UI design - light blue with blue text
		case AccountStatuses.COMPLETED:
			return "bg-[#D1FADF] text-[#05603A] border-[#05603A]"; // Light emerald with dark green text
		default:
			return "bg-gray-100 text-gray-800";
	}
};
